module.exports = __webpack_public_path__ + "img/jonathan-cooper-VxO9SHCKK68-unsplash.41209934.jpg";